module.exports = __webpack_public_path__ + "img/dbg5.8f6774cd.jpg";